/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import Button from "../../../common/core/Button";
import Modal from "../../../common/core/Modal";
import ModalHeader from "../../../common/core/ModalHeader";
import ModalBody from "../../../common/core/ModalBody";
import ModalFooter from "../../../common/core/ModalFooter";
import Form from "../../../common/core/Form";
import Alert from "../../../common/core/Alert";
import Spinner from "../../../common/core/Spinner";

const DeleteProductBrandModal = (props) => {
  const {
    modalContents,
    deleteModal,
    handleDeleteConfirmationModal,
    deleteProductBrandInProgress,
    message,
    handleDeleteProductBrand,
  } = props;
  return (
    <>
      <Modal
        isOpen={deleteModal}
        toggle={() => handleDeleteConfirmationModal(modalContents)}
        centered
        backdrop="static"
      >
        <ModalHeader toggle={() => handleDeleteConfirmationModal(modalContents)}>
          Delete Product Brand
        </ModalHeader>
        { deleteProductBrandInProgress
          ? (
            <div className="d-flex align-items-center justify-content-center">
              <Spinner />
            </div>
          )
          : (
            <>
              {
                message && message.type === "warning" && (
                  <Alert color={message.type}>
                    {message.message}
                  </Alert>
                )
              }
            </>
          )}
        <ModalBody>
          <Form>
            <p className="mb-4 text-center">
              Do you really want to delete the product brand
              <br />
              {modalContents && modalContents.brandName && (
                <>
                  <span className="fw-bold pt-2 d-inline-block">
                    {modalContents.brandName}
                  </span>
                </>
              )}
               &nbsp;?
            </p>
            <ModalFooter>
              <Button color="primary" className="btn-radius" onClick={() => handleDeleteProductBrand(modalContents.id)} disabled={deleteProductBrandInProgress}>Yes</Button>
              <Button color="light" className="btn-radius" onClick={() => handleDeleteConfirmationModal(modalContents)}>No</Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

DeleteProductBrandModal.propTypes = {
  modalContents: PropTypes.objectOf(PropTypes).isRequired,
  deleteModal: PropTypes.bool.isRequired,
  handleDeleteConfirmationModal: PropTypes.func.isRequired,
  deleteProductBrandInProgress: PropTypes.bool.isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  handleDeleteProductBrand: PropTypes.bool.isRequired,
};
export default DeleteProductBrandModal;
